const en = {
    addMember: 'Add member',
    avatar: 'Avatar',
    phNumber: 'Phone number',
    permissions: 'Permissions',
    isAdmin: 'Set as system administrator',
    acntExists: 'Account already exists',
    addSuccess: 'Added successfully',
    addFailed: 'Add failed',
    tips: 'Tips',
    confirmAction: 'Are you sure you want to',
    disable: 'disable',
    enable: 'enable',
    bascInfoUp: 'Basic information modified successfully',
    userPerSetSuc: 'User permissions set successfully',
    pwdChanged: 'Password modified successfully',
    mobileChangeSuc: 'Mobile number successfully modified',
    aginLogin: 'Please log in again!',
    validaFailed: 'Verification failed',
    pwd: 'Password',
    enterPwd: 'Please enter password',
    pwdMinLength: 'Password must be at least 6 characters',
    plConfirmPwd: 'Please confirm password',
    confirmPwd: 'Confirm password',
    pwdDiff: 'The two passwords do not match',
    reenterPwd: 'Please confirm password again',
    memberDetails: 'Member details',
    basicInfo: 'Basic information',
    searchPrompt: 'Please enter name1, name2, and phone number to search',
    sure: 'OK',
    viewDetails: 'View details',
    thisMember: 'this member',
    maxLengthTip: 'The content exceeds the maximum length limit!',
    changeStatusSucc: 'Operation successful!',
    phNumberTip: 'Please enter your phone number',
    updateFail: 'Modification failed',
    userDataNoExistTip: 'User data does not exist or the user is disabled',
    mobileEmpty: 'The phone number cannot be empty',
    userFetchFail: 'Failed to obtain user information',
    name1: 'Name1',
    name2: 'Name2',
};

export default en;